import { isArray } from 'util';

import { sortByString, mapCollection } from '../../utils/collection.utils';
import { User } from '../user';

export class UserBuilder {

  static fromJson(json): User {
    return (json) ? new User(
      json.hash,
      json.firstName,
      json.lastName,
      json.email,
      json.role
    ) : null;
  }

  static fromJsonList(list): User[] {
    return (isArray(list)) ? sortByString('firstName', mapCollection(UserBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/user-builder.ts